import { useMemo } from "react";
import { useLocationStore, useMapStore } from "..";
import IEntityWithIcon from "../interfaces/IEntityWithIcon";
import ILocation from "../interfaces/ILocation";
import useLocationsWithGlobalFilters from "./useLocationsWithGlobalFilters";
import useVisibleOnMapCompanyIds from "./useVisibleOnMapCompanyIds";

export default function useVisibleLocationsOnMap(): ILocationWithIcon[] {
    const locationStore = useLocationStore();
    const mapStore = useMapStore();
    const visibleOnMapCompanyIds = useVisibleOnMapCompanyIds();

    const locationsForVisibleCompanies = useMemo(() => {
        return locationStore.locations.filter(l => visibleOnMapCompanyIds.includes(l.pipedriveCompanyId));
    }, [locationStore.locations, visibleOnMapCompanyIds]);

    const locations = useLocationsWithGlobalFilters(locationsForVisibleCompanies);

    return useMemo(() => locations.map(l => ({
        ...l,
        icon: mapStore.loadedLogoCompanyIds.includes(l.pipedriveCompanyId)
            ? `location-marker-company-${l.pipedriveCompanyId}`
            : "location-marker",
    })), [locations, mapStore.loadedLogoCompanyIds],);
}

export type ILocationWithIcon = ILocation & IEntityWithIcon;
